import type {ReactElement, ReactNode} from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import type {ToggleSwitchV2Size} from '@Components/toggle-switch-v2';
import {ToggleSwitch} from '@Components/toggle-switch-v2';

interface ContextualMenuToggleOptionProps {
  id: string;
  label: string;
  className?: string;
  subOptionsClassname?: string;
  labelClassName?: string;
  isLabelBold?: boolean;
  isChecked: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;

  onClick(): void;
  onMouseEnter?(): void;
  onMouseLeave?(): void;

  /**
   * for suboptions
   */
  children?: ReactNode;
  tag?: ReactNode;
  toggleSize?: ToggleSwitchV2Size;
}

export function ContextualMenuToggleOption({
  className = '',
  subOptionsClassname = '',
  isDisabled = false,
  children = null,
  onMouseEnter = (): void => {},
  onMouseLeave = (): void => {},
  ...props
}: ContextualMenuToggleOptionProps): ReactElement<any> | null {
  return (
    <Option
      subOptionClassName={subOptionsClassname}
      key={props.id}
      label={props.label}
      labelClassName={props.labelClassName}
      isLabelBold={props.isLabelBold}
      className={className}
      tag={props.tag}
      optionControl={
        <ToggleSwitch
          onMouseEnter={(): void => {
            onMouseEnter();
          }}
          onMouseLeave={(): void => {
            onMouseLeave();
          }}
          id={props.id}
          isChecked={props.isChecked}
          isLoading={props.isLoading}
          onChange={(): void => {
            props.onClick();
          }}
          elementTitle={props.label}
          isDisabled={isDisabled}
          size={props.toggleSize}
        />
      }
    >
      {children}
    </Option>
  );
}
